import script from "./VRList.vue?vue&type=script&setup=true&lang=ts"
export * from "./VRList.vue?vue&type=script&setup=true&lang=ts"

import "./VRList.vue?vue&type=style&index=0&id=fac8d32c&scoped=true&lang=css"

import exportComponent from "D:\\work\\kaifengzimaoqu\\wt_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fac8d32c"]])

export default __exports__